import { create } from "zustand";
import { ChatFilterState, FilterState } from "../../types";

const filterSet = (set: any) => ({
    sortField: 'status.order',
    setSortField: (sortField: string) => set({ sortField }),
    sortDirection: 1,
    setSortDirection: (sortDirection: number) => set({ sortDirection }),
    orderDateQuery: '',
    setOrderDateQuery: (orderDateQuery: string) => set({ orderDateQuery }),
    consumerNameQuery: '',
    setConsumerNameQuery: (consumerNameQuery: string) => set({ consumerNameQuery }),
    orderIdQuery: '',
    setOrderIdQuery: (orderIdQuery: string) => set({ orderIdQuery }),
    producerNameQuery: '',
    setProducerNameQuery: (producerNameQuery: string) => set({ producerNameQuery }),
    orderSourceQuery: '',
    setOrderSourceQuery: (orderSourceQuery: string) => set({ orderSourceQuery }),
    orderStatusQuery: '',
    setOrderStatusQuery: (orderStatusQuery: string) => set({ orderStatusQuery }),
    orderTabSelect: '',
    setOrderTabSelect: (orderTabSelect: string) => set({ orderTabSelect }),
    dateBounds: {
        startDate: null,
        endDate: null,
    },
    setDateBounds: (dateBounds: any) => set({ dateBounds }),
    generalSearchQuery: '',
    setGeneralSearchQuery: (generalSearchQuery: string) => set({ generalSearchQuery }),
});

const chatFilterSet = (set: any) => ({
    chatroomFilter: 'all',
    setChatroomFilter: (chatroomFilter: string) => set({ chatroomFilter }),
});

export const useOrderHistoryFilters = create<FilterState>(filterSet);
export const useActiveOrderFilters = create<FilterState>(filterSet);
export const useChatFilters = create<ChatFilterState>(chatFilterSet);